import React, { useContext } from 'react';
import { FormattedMessage as IntlFormattedMessage } from 'react-intl';
import { translationsNamespaceContext } from '../contexts/TranslationsNamespaceProvider/translationsNamespaceContext';
import { jsx as _jsx } from "react/jsx-runtime";
/**
 * Renders a formatted internationalized message using the provided translation data.
 * @remarks Use in case of translation with HTML components instead of formatMessage accessible from useTranslations hook
 *
 * @template T The type of the translation data.
 *
 * @example
 * // Basic usage
 * <FormattedMessage<DefaultTranslations> id="greeting" />
 *
 * @description
 * This component is used for rendering internationalized messages. It combines the provided `id` with
 * the current translation namespace to retrieve the corresponding translation message.
 *
 * @see {@link FormattedMessageProps} for the available props and options.
 */
export const FormattedMessage = ({
  id,
  ...props
}) => {
  const {
    namespace
  } = useContext(translationsNamespaceContext);
  return /*#__PURE__*/_jsx(IntlFormattedMessage, {
    id: `${namespace}:${String(id)}`,
    ...props
  });
};
//# sourceMappingURL=FormattedMessage.js.map